import styled from 'styled-components';

import { Flex } from '@/components/base';

const DefaultItem = styled(Flex).attrs({
  a: 'center',
})`
  height: 32px;
  cursor: pointer;
  background-color: ${(props) => props.theme.colors.ND00};
  transition: all 0.2s;
  padding: 0 11px;
  border-radius: 4px;

  &:hover {
    background-color: ${(props) => props.theme.colors.ND04};
  }
`;

export default DefaultItem;
